/**
 * Color Constants
 *
 * Shared color definitions used across config files.
 * Separated to avoid circular dependencies.
 */

import type { FilterTagId, NewsTagColor } from '@/types'

export const CARD_GRADIENTS = {
  red: 'linear-gradient(176.12deg, #FF6684 16.91%, #FF6684 69.37%) ',
  blue: 'linear-gradient(355.57deg, #66B4D3 27.25%, #66FFFF 78.34%)',
  green: 'linear-gradient(175.27deg, #66BE92 24.41%, #91FC9D 70.38%)',
  white: 'linear-gradient(175.29deg, #EBEBEB 17.8%, #EAEAEA 64.69%)',
  yellow: 'linear-gradient(355.82deg, #FFD166 24.49%, #FFF766 74.33%)',
  black: 'linear-gradient(355.67deg, #2B2B2B 21.7%, #848484 76.45%)'
} as const

export const FILTER_COLORS: Record<FilterTagId, NewsTagColor> = {
  all: { background: '#888888', text: '#ffffff' },
  build: { background: '#000000', text: '#ffffff' },
  grow: { background: '#FFB300', text: '#000000' },
  invest: { background: '#0082B6', text: '#ffffff' },
  win: { background: '#00944A', text: '#ffffff' },
  support: { background: '#FF0031', text: '#ffffff' },
  impact: { background: '#ffffff', text: '#000000' }
}

// Mapping from color slugs to section names
export const SLUG_TO_SECTION = {
  blue: 'invest',
  black: 'build',
  red: 'support',
  white: 'impact',
  yellow: 'grow',
  green: 'win'
} as const

export type ColorSlug = keyof typeof SLUG_TO_SECTION
export type SectionName = typeof SLUG_TO_SECTION[ColorSlug]
